import React from 'react';
import PropTypes from 'prop-types';

import { HFBlock } from 'components';
import { getLang, getImage } from 'utils/Contentful';
import * as localeMap from './locale';
import './contact-page.css';

class ContactPage extends React.PureComponent {

  constructor() {
    super();
    this.state = {
      lang: {},
      images: {kv: []}
    }
  }

  componentDidMount() {
    this.setImage();
    this.setLang(this.props.localeCode);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.localeCode !== this.props.localeCode &&
       !this.state.lang[this.props.localeCode]
    ) {
      this.setLang(this.props.localeCode);
    }
  }

  setLang = localeCode => {
    getLang(localeCode, 'Contact').then(() => {
      this.setState({
        lang: {
          ...this.state.lang,
        }
      });
    });
  }

  setImage = () => {
    getImage('Contact').then(({kv}) => {
      this.setState({
        images: {
          kv: kv.map(item =>
            item ? item.fields.file.url : ""
          )
        }
      });
    })
  }

  render() {
    console.log(localeMap, this.props.locale);
    let lang = localeMap[this.props.locale];
    // lang = this.state.lang[this.props.localeCode];
    if(!lang) return null;
    const { images: { kv } } = this.state;
    return (
      <HFBlock
        className="contact-page"
        {...this.props}
      >
        <div className="kv" style={{backgroundImage: kv[0] ? `url(${kv[0]})` : ""}}>
          <div className="container">
            <div className="heading">{lang.heading}</div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6 info">
              {Object.keys(lang.info).map(key =>
                <dl className="row" key={key}>
                  <dt className="col-md-4 field">{lang.info[key].field}:</dt>
                  <dd className="col-md-8">{lang.info[key].value}</dd>
                </dl>
              )}
            </div>
            <div className="col-md-6">
              <iframe src={lang.map} title="map" width="100%" height="450" style={{border: 0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
          <div className="type-title">{lang.type.title}</div>
          <div className="row">
            {lang.type.list.map((item, i) =>
              <div className="col-md-4 item" key={i}>
                <div className="title">{item.title}</div>
                <div className="text">{item.text}</div>
              </div>
            )}
          </div>
        </div>
      </HFBlock>
    );
  }
}

export default ContactPage;

ContactPage.propTypes = {
  locale: PropTypes.string,
}

ContactPage.defaultProps = {
  locale: "",
}



// WEBPACK FOOTER //
// ./src/pages/ContactPage/index.js